import React from 'react';
import { PortableText } from '@portabletext/react';

const portableTextComponents = {
    marks: {
        link: ({ children, value }) => {
            const href = value?.href;
            if (!href) return children;

            return (
                <a href={href} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );
        },
    },
};

const renderTextWithBreaks = (text) => text
    .split('\n')
    .reduce((segments, segment, index) => {
        if (index === 0) return [segment];
        return [...segments, <br key={`line-break-${index}`} />, segment];
    }, []);

export const renderRichContent = (content) => {
    if (!content) return null;

    if (typeof content === 'string') {
        return renderTextWithBreaks(content);
    }

    if (Array.isArray(content)) {
        return <PortableText value={content} components={portableTextComponents} />;
    }

    return null;
};